export const FETCH_HAS_SOURCE_DOWNLOADS = 'mac/FETCH_HAS_SOURCE_DOWNLOADS';
